module.exports = __webpack_public_path__ + "static/media/apartment16.b1a243be.jpg";